import { presentVideoPlayer } from "../helpers/video-player";
import Swiper from 'swiper';
import { Pagination, Autoplay, EffectFade} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { isIE } from '../helpers/browser-detection';

export const HomeController = {
  init() {
    if (!isIE) {
      this.initSliders();
    }
    this.initVideoSlideWatchers();
    this.initTestimonialsSwiper();

  },
  playVideo: link => e => {
    e.preventDefault();
    presentVideoPlayer(link);
  },
  
  initVideoSlideWatchers() {
    const els = document.querySelectorAll('[data-video-link]');
    Array.from(els).forEach(el => {
      const link = el.getAttribute('data-video-link');
      if (link) {
        el.addEventListener('click', this.playVideo(link));
      }
    })
  },

  initSliders() {
    if (document.getElementById('section-main-slider')) {
      new Swiper('#section-main-slider', {
        modules: [Pagination, Autoplay, EffectFade],
        // speed: 618,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    }
    if (document.getElementById('homepage-interview-videos-slider')) {
      new Swiper('#homepage-interview-videos-slider', {
        modules: [Autoplay],
        loop: true,
        spaceBetween: 12,
        // speed: 618,
        slidesPerView: 1.5,
        breakpoints: {
          480: {
            slidesPerView: 2.5,
            spaceBetween: 12,
          },
          768: {
            spaceBetween: 24,
            slidesPerView: 3.5,
          },
          1366: {
            spaceBetween: 24,
            slidesPerView: 4.5,
          },
        },
        autoplay: {
          delay: 5000,
        },
      });
    }
  },

  initMarqueeSlider() {
    var marquee = new Swiper('.marquee-slider__container', {
      modules: [Autoplay],
      spaceBetween: 0,
      centeredSlides: true,
      speed: 5000,
      autoplay: {
        delay: 0,
      },
      grabCursor: true,
      loop: true,
      slidesPerView:'auto',
      allowTouchMove: false,
      disableOnInteraction: true,
      simulateTouch:true,

    });
    $('.marquee-slider__container').mouseenter(function() { 
      marquee.autoplay.stop();
     }); 
      $('.marquee-slider__container').mouseleave(function() { 
        marquee.autoplay.start(); 
      });
  
  },
  initTestimonialsSwiper() {
    if(document.querySelector('.testimonial__thumbs-swiper-container')) {
      var galleryThumbs = new Swiper('.testimonial__thumbs-swiper-container', {
        slidesPerView: 8,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        spaceBetween: 0,
        allowTouchMove: false, 
      });
    }
  
    if(document.querySelector('.testimonials__quote-swiper-container')) {
      new Swiper('.testimonials__quote-swiper-container', {  
        modules: [Autoplay],    
        loop: true,
        thumbs: {
          swiper: galleryThumbs,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
      });
    }
  },
  initSliderSet (id, thumbsId)  {
    const thumbs = new Swiper(thumbsId, {
      spaceBetween: 24,
      slidesPerView: 4,
      freeMode: true,
      loop: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
    });
    new Swiper(id, {
      spaceBetween: 0,
      loop: true,
      // speed: 382,
      slidesPerView: 1,
      thumbs: {
        swiper: thumbs
      }
    });
  },
}